import { styled } from "@mui/system";
import Button from "@mui/material/Button";

const PrimaryButton = styled(Button)`
  && {
    background: linear-gradient(180deg, #1a73e8 0%, #1558c0 100%);
    color: #ffffff;
    border: 1.5px solid #1558c0;
    border-radius: 6px;
    box-shadow: 0 3px 10px rgba(26, 115, 232, 0.35);
    text-transform: capitalize;
    min-width: 6.5rem;
    width: fit-content;
    padding: 0.55rem 1.1rem;
    font-weight: 500;
    letter-spacing: 0.3px;
    cursor: pointer;
    transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      background: linear-gradient(180deg, #1558c0 0%, #0f4ab8 100%);
      box-shadow: 0 6px 18px rgba(26, 115, 232, 0.45);
      transform: translateY(-1px);
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0 3px 8px rgba(26, 115, 232, 0.35);
    }

    &:disabled {
      background: #e0e0e0;
      color: #a0a0a0;
      border-color: #cfcfcf;
      box-shadow: none;
      cursor: not-allowed;
      transform: none;
    }
  }
`;

export default PrimaryButton;
